/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function security(instance) {
	return {
		/**
		 * @param {string} firstName
		 * @param {string} lastName
		 * @param {number} pageNumber
		 * @param {number} pageSize
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllUsers: (firstName, lastName, pageSize, pageNumber, config = {}) => {
			const pagingParams =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}&`
					: ''
			const nameParam = firstName ? `firstName=${firstName}&` : ''
			const surnameParam = lastName ? `lastName=${lastName}&` : ''
			return instance.get(
				`users${pagingParams}${nameParam}${surnameParam}`,
				config
			)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		create: (body, config = {}) => {
			return instance.post('users', body, config)
		},

		/**
		 * @param {string } id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		delete: (id, config = {}) => {
			return instance.delete(`users/${id}`, config)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		resetPassword: (body, config = {}) => {
			return instance.post(`users/rest-password`, body, config)
		},

		/**
		 * @param {string } id
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		updatePermissions: (id, body, config = {}) => {
			return instance.patch(`users/${id}`, body, config)
		},

		/**
		 * @param {string } id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getPermissions: (id, config = {}) => {
			return instance.get(`users/${id}`, config)
		}
	}
}
